import { useLocation } from 'react-router';
import {
    Button,
    Caption,
    useAppDisplayModeContext,
    useStyles,
} from '@archipro-design/aria';
import { ArrowLeftSlim } from '@archipro-design/icons';
import * as S from '@modules/directory/component/BackToTopButton.style';
import StickyAction from '@modules/directory/component/StickyAction';
import { useTracker } from '@archipro-website/tracker';
import { useCountryContext } from '@archipro-website/localisation';
import { AOC_BLACK_LIST } from '@archipro-website/top-navigation';

const RIGHT_OFFSET = 33;

const AOC =
    'At ArchiPro we recognise and acknowledge the existing, original and ancient connection Aboriginal and Torres Strait Islander peoples have to the lands and waterways across the Australian continent. We pay our respects to the elders past and present. We commit to working together to build a prosperous and inclusive Australia.';

const BackToTopButton = () => {
    const { code } = useCountryContext();
    const { desktop } = useAppDisplayModeContext();
    const { css } = useStyles();
    const location = useLocation();
    const tracker = useTracker();

    if (!desktop) {
        return null;
    }

    const pathSegments = location.pathname.split('/');
    const displayExcludedAoc = pathSegments[1]
        ? AOC_BLACK_LIST.includes(pathSegments[1])
        : false;

    return (
        <>
            {displayExcludedAoc && code === 'AU' && (
                // sticky buttons works only when it's in the scrollable parent div
                // workaround by excluding it from footer and render it here in order to sticky it below the aoc section.
                <div className={css(S.AOCSectionContainer)}>
                    <div className={css(S.AOCSection)}>
                        <Caption variant="03">{AOC}</Caption>
                    </div>
                </div>
            )}
            <StickyAction
                position={{
                    right: RIGHT_OFFSET,
                    bottom: 13,
                }}
                revealBounds={[1200]}
                width={60}
                height={72}
                usePxValues={true}
            >
                <Button
                    className={css(S.BackToTopButton)}
                    variables={{
                        buttonPadding: 12,
                        iconPadding: 0,
                        buttonRadius: '50%',
                    }}
                    color="white"
                    icon={<ArrowLeftSlim />}
                    onClick={() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        tracker.log('BackToTopButtonClick', {
                            url: new URL(window.location.href),
                            targetTracker: 'archiproTracker',
                        });
                    }}
                >
                    To Top
                </Button>
            </StickyAction>
        </>
    );
};

export default BackToTopButton;
